import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OpeningHook() {
  return <section className="bg-white py-24 px-6" data-id="element-149">
      <div className="max-w-3xl mx-auto" data-id="element-150">
        <FadeIn data-id="element-151">
          <div className="border-l-4 border-amber pl-6 md:pl-10 py-2" data-id="element-152">
            <p className="text-xl md:text-2xl leading-[1.8] text-charcoal font-heading" data-id="element-153">
              You love your parents, but you've already spent hours trying to
              explain how to join a FaceTime call...{' '}
              <span className="italic" data-id="element-154">only to see the ceiling fan again</span>,
              or where a "lost" photo went.
            </p>
            <p className="text-xl md:text-2xl leading-[1.8] text-charcoal font-heading mt-6" data-id="element-155">
              You've walked them through it 100 times, but without a clear map,
              they still feel like a burden—and you're still their 24/7 help
              desk.
            </p>
            <p className="text-2xl md:text-3xl leading-[1.6] text-amber font-bold font-heading mt-8" data-id="element-156">
              It's time to give them the keys to the family circle.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}